// Server clock estimate. Deadlines arrive as absolute server epoch ms; every phone converts them
// with its own offset so countdowns agree around the table. The offset comes from ping/pong round
// trips: of the last few samples, the one with the lowest round trip is the most trustworthy.

interface Sample {
  offset: number;
  rtt: number;
}

const MAX_SAMPLES = 5;

export class ClockSync {
  private samples: Sample[] = [];

  /** Record a round trip: sent at `sentAt` (client ms), server stamped `serverTs`, got back at `recvAt`. */
  addSample(sentAt: number, serverTs: number, recvAt: number): void {
    const rtt = Math.max(0, recvAt - sentAt);
    const offset = serverTs + rtt / 2 - recvAt;
    this.samples.push({ offset, rtt });
    if (this.samples.length > MAX_SAMPLES) this.samples.shift();
  }

  get offsetMs(): number {
    if (this.samples.length === 0) return 0;
    let best = this.samples[0];
    for (const s of this.samples) if (s.rtt < best.rtt) best = s;
    return Math.round(best.offset);
  }

  get sampleCount(): number {
    return this.samples.length;
  }

  serverNow(clientNow: number = Date.now()): number {
    return clientNow + this.offsetMs;
  }
}
